export default {
    TITLE: 'TITLE',
    SUBTITLE: 'SUBTITLE',
    SUPPORT_TEXT: 'SUPPORT_TEXT',
    
    INITIAL_FLOWS_HEADER: 'INITIAL_FLOWS.HEADER',
    INITIAL_FLOWS_FLOWS_LABEL: 'INITIAL_FLOWS.FLOWS.LABEL_',
    INITIAL_FLOWS_FLOWS_NAME: 'INITIAL_FLOWS.FLOWS.NAME_',

    AGENT_DESK_FORM_HEADER: 'AGENT_DESK_FORM.HEADER',
    AGENT_DESK_FORM_FORM_FIELDS_LABEL: 'AGENT_DESK_FORM.FORM_FIELDS.LABEL_',
    AGENT_DESK_FORM_FORM_FIELDS_NAME: 'AGENT_DESK_FORM.FORM_FIELDS.NAME_',
    AGENT_DESK_FORM_FORM_FIELDS_PLACEHOLDER: 'AGENT_DESK_FORM.FORM_FIELDS.PLACEHOLDER_',
    AGENT_DESK_FORM_SUBMIT_BUTTON_TEXT: 'AGENT_DESK_FORM.SUBMIT_BUTTON_TEXT',
    AGENT_DESK_FORM_FORM_TITLE: 'AGENT_DESK_FORM.FORM_TITLE',
    AGENT_DESK_FORM_REJECT_FORM_TEXT: 'AGENT_DESK_FORM.REJECT_FORM_TEXT',
    AGENT_DESK_FORM_FORM_SUBMISSION_TEXT: 'AGENT_DESK_FORM.FORM_SUBMISSION_TEXT',

    END_CHAT_SEND_TRANSCRIPT_CTA: 'END_CHAT.SEND_TRANSCRIPT_CTA',
    END_CHAT_BUTTON_CTA: 'END_CHAT.END_CHAT_BUTTON_CTA',
    END_CHAT_QUERY: 'END_CHAT.END_CHAT_QUERY',

    SUPPORT_ICON_DETAILS_VALUE: 'SUPPORT_ICON_DETAILS.VALUE',
    SUPPORT_ICON_DETAILS_TEXT: 'SUPPORT_ICON_DETAILS.TEXT',

    INACTIVE_OVERLAY_DESCRIPTION_TEXT: 'INACTIVE_OVERLAY.DESCRIPTION_TEXT',
    INACTIVE_OVERLAY_RESUME_BUTTON_TEXT: 'INACTIVE_OVERLAY.RESUME_BUTTON_TEXT',
    INACTIVE_OVERLAY_RESTART_BUTTON_TEXT: 'INACTIVE_OVERLAY.RESTART_BUTTON_TEXT',

    CALLOUT_BUBBLE_INTENT: 'CALLOUT_BUBBLE.INTENT',
    CALLOUT_BUBBLE_ATTACHMENTS_TEXT: 'CALLOUT_BUBBLE.ATTACHMENTS.TEXT_',
    CALLOUT_BUBBLE_OPTIONS_LABEL: 'CALLOUT_BUBBLE.OPTIONS.LABEL_',
    CALLOUT_BUBBLE_OPTIONS_METADATA: 'CALLOUT_BUBBLE.OPTIONS.METADATA_',

    QUICK_MENU_OPTIONS_LABEL: 'QUICK_MENU_OPTIONS.LABEL_',
    QUICK_MENU_OPTIONS_TEXT: 'QUICK_MENU_OPTIONS.TEXT_',

    RESTART_CHAT_WARNING_PRIMARY_CTA: 'SHOW_WARNING.RESTART_BUTTON_TEXT',
    RESTART_CHAT_WARNING_SECONDARY_CTA: 'SHOW_WARNING.CANCEL_BUTTON_TEXT',
    RESTART_CHAT_DESCRIPTION: 'SHOW_WARNING.WARNING_TEXT'
}